import type { SearchRequest } from '../types/search-request.dto';
import type { SearchRequestModel } from '../types/search-request.model';

export const toSearchRequestDto = (request: SearchRequestModel): SearchRequest => {
	return {
		page_size: request.pageSize ?? 100,
		organization_ids: request.organizationIds ?? [],
		organization_name: request.organizationName,
		organization_cities: request.organizationCities,
		organization_countries: request.organizationCountries,
		start_time: request.startTime,
		end_time: request.endTime,
		time_type: request.timeType ?? 'daily',
		continuation_token: request.continuationToken,
	};
};
